<template>
  <template v-for="node in newArrangedNodes" :key="node.key">
    <component
      :is="resolveStoryBlokComponent(node.content.blok)"
      v-if="node.type === 'blok'"
      :blok="node.content.blok.content"
    />
    <div v-else v-html="node.content" />
  </template>
</template>

<script setup lang="ts">
import type { ISbRichtext } from "@storyblok/vue";

const props = defineProps<{
  articleContent: ISbRichtext | undefined;
}>();

const resolveStoryBlokComponent = (story: {
  component: string;
  content: { component: string };
}) => {
  if (!story) {
    return null;
  }
  return resolveComponent(story?.component || story?.content?.component);
};

const nodes = computed(() => {
  const nodes: { key: string; type: string; content: unknown }[] = [];
  if (props.articleContent?.content) {
    Object.entries(props.articleContent.content).forEach(([key, node]) => {
      if (node.type === "blok") {
        for (let i = 0; i < node.attrs?.body?.length; i++) {
          const blok = {
            content: node.attrs?.body?.[i],
          };
          nodes.push({
            key,
            type: "blok",
            content: {
              blok,
            },
          });
        }
      } else if (node.content && node.content[0].type === "image") {
        node.content[0].attrs.src = `${node.content[0].attrs.src}/m/`;
        nodes.push({
          key,
          type: "html",
          content: useStoryblokApi().richTextResolver.render({
            type: node.type,
            content: [node],
          } as ISbRichtext),
        });
      } else {
        nodes.push({
          key,
          type: "html",
          content: useStoryblokApi().richTextResolver.render({
            type: node.type,
            content: [node],
          } as ISbRichtext),
        });
      }
    });
  }
  return nodes;
});

const rearrangedNodes = () => {
  const originalNodes = nodes.value;
  const result: { key: string; type: string; content: unknown }[] = [];
  let concatNodeContent = "";

  originalNodes.forEach((node) => {
    if (node.type === "blok") {
      if (concatNodeContent) {
        result.push({
          key: node.key,
          type: "html",
          content: concatNodeContent,
        });
        concatNodeContent = "";
      }
      result.push(node);
    } else {
      concatNodeContent += node.content;
    }
  });

  if (concatNodeContent) {
    result.push({
      key: originalNodes[originalNodes.length - 1].key,
      type: "html",
      content: concatNodeContent,
    });
  }

  return result;
};

const newArrangedNodes = rearrangedNodes();
</script>
